import {createAction} from 'redux-actions';
import {push, replace} from "connected-react-router";
import {batchActions} from "redux-batched-actions";
import stickerRepository from "../../domain/repositories/StickerRepository";
import {canSendNotification, notificationIsSent} from "../../ui/screens/sticker-item-show/helpers";
import {stickerSelector} from "../entities/stickers/selectors";
import {stickerShowStateSelector} from "./selectors";
import {
    currentUserInfoSelector,
    isCurrentUserLoggedSelector
} from "../../../auth/store/auth-user/selectors";
import stickerCommentRepositoryBuilder from "../../domain/factories/StickerCommentsRepositoryBuilder";
import {showContinueOrFreshModal} from "../drafts/actions";
import {
    setScannedStickerItem,
    setScannedStickerItemRequest,
    setTextTemplatesGroup,
    setTheme,
    setThemeGroup
} from "../create-llama/actions";
import cacheManager from "../../domain/services/StickerCache";
// import {loadStickerItems} from "../entities/sticker-items/actions";
import stickerItemsRepositoryBuilder from "../../domain/factories/StickerItemsRepositoryBuilder";
import {IStickerItem} from "../entities/sticker-items/reducer";
import {
    defaultTextTemplatesGroupSelector,
    defaultThemeGroupSelector,
    defaultThemeTemplateSelector
} from "../dictionaries/selectors";

const namespace = 'SHOW_LLAMA';

export const setAttachingStickerAfterLogin = createAction(`${namespace}/SET_ATTACHING_STICKER_AFTER_LOGIN`);

export const stickerLoadRequest = createAction(`${namespace}/STICKER_LOAD_REQUEST`);
export const stickerLoadSuccess = createAction(`${namespace}/STICKER_LOAD_SUCCESS`);
export const stickerLoadFailed = createAction(`${namespace}/STICKER_LOAD_FAILED`);

export const commentsLoadRequest = createAction(`${namespace}/COMMENTS_LOAD_REQUEST`);
export const commentsLoadSuccess = createAction(`${namespace}/COMMENTS_LOAD_SUCCESS`);
export const commentsLoadFailed = createAction(`${namespace}/COMMENTS_LOAD_FAILED`);

export const stickerAttachRequest = createAction(`${namespace}/STICKER_ATTACH_REQUEST`);
export const stickerAttachSuccess = createAction(`${namespace}/STICKER_ATTACH_SUCCESS`);
export const stickerAttachFailed = createAction(`${namespace}/STICKER_ATTACH_FAILED`);

export const setPassword = createAction(`${namespace}/SET_PASSWORD`);
export const setFormErrors = createAction(`${namespace}/SET_FORM_ERRORS`);
export const resetFormErrors = createAction(`${namespace}/RESET_FORM_ERRORS`);
export const setPasswordModalVisibility = createAction(`${namespace}/SET_PASSWORD_MODAL_VISIBILITY`);
export const setAttachModalVisibility = createAction(`${namespace}/SET_ATTACH_MODAL_VISIBILITY`);
export const setScanCongratulationsVisibility = createAction(`${namespace}/SET_SCAN_CONGRATULATIONS_VISIBILITY`);
export const setAttachSuccessModalVisibility = createAction(`${namespace}/SET_ATTACH_SUCCESS_MODAL_VISIBILITY`);
export const setAttachModalClosedFlag = createAction(`${namespace}/SET_ATTACH_MODAL_CLOSED_FLAG`);

export const stickerShowCongratulation = createAction(`${namespace}/STICKER_SHOW_CONGRATULATION_SET`);

export function loginForAttachToSticker(sticker: any) {
    return (dispatch, getState) => {
        localStorage.setItem('stikerForAttach', JSON.stringify(sticker));
        dispatch(batchActions([
            setAttachingStickerAfterLogin(sticker),
            replace('/login')
        ]));
    };
}

export function loadSticker(stickerId, options = {creatingScreen: ''}) {
    return async (dispatch, getState) => {
        if (!stickerId) {
            return;
        }

        dispatch(stickerLoadRequest());
        let sticker = stickerSelector(getState(), stickerId);
        if (!sticker) {
            sticker = (await stickerRepository.loadById(stickerId)).data;

            if (!sticker) {
                return;
            }
        }
        const state = stickerShowStateSelector(getState());
        const isLogged = isCurrentUserLoggedSelector(getState());
        const notificationModeAsleep = (new URL(String(document.location))).searchParams.get('mode') === 'asleep';
        const requestParams = (state.password !== '' ? {password: state.password} : {}) as any;
        const needSendNotification = !location.pathname.match('stickers') ? canSendNotification(stickerId) : false;
        if (needSendNotification && !notificationModeAsleep) {
            requestParams.source = 'web';
        }
        if (needSendNotification) {
            notificationIsSent(stickerId);
        }
        if (sticker.configured_date != null) {
            const {stickerForAttach} = state;
            if (stickerForAttach != null && sticker.id === stickerForAttach.id && isLogged && !sticker.is_my_llama) {
                dispatch(attachStickerToCurrentUser(sticker));
            } else if (!sticker.is_my_llama && !location.pathname.match('stickers') /*&& sticker.type === "GREETING"*/) {
                dispatch(setScanCongratulationsVisibility(true));
                // dispatch(startAttachingTimer(sticker));
            }
            if (!location.pathname.match('stickers')) {
                dispatch(push(`/stickers/${stickerId}`));
            }
            const actions = [
                stickerLoadSuccess(sticker)
            ];
            // actions.push(loadStickerItems(sticker.id))
            dispatch(batchActions(actions));

        } else {
            // dispatch(loadStickerItems(stickerId))
            //     .then(() => dispatch(addStickerItem(stickerId, options)));
            dispatch(addStickerItem(stickerId, options))
        }
    };
}


export function addStickerItem(stickerId: string, options = {creatingScreen: ''}): (dispatch, getState) => Promise<any> {
    return async (dispatch, getState) => {
        dispatch(setThemeGroup(defaultThemeGroupSelector(getState())))
        dispatch(setTheme(defaultThemeTemplateSelector(getState())))
        dispatch(setTextTemplatesGroup(defaultTextTemplatesGroupSelector(getState())))
        dispatch(setScannedStickerItemRequest());
        dispatch(stickerShowCongratulation(false));
        return stickerItemsRepositoryBuilder
            .buildWithStickerId(stickerId)
            .create({})
            .then((response) => response.data)
            .then((stickerItem: IStickerItem) => {
                dispatch(setScannedStickerItem(stickerItem));
                return cacheManager.getCachedSticker(stickerItem.sticker_id)
                    .then((cachedSticker: any) => {
                        if (cachedSticker && cachedSticker.media) {
                            dispatch(showContinueOrFreshModal(cachedSticker));
                        } else {
                            dispatch(batchActions([
                                // push(`/stickers/${stickerId}/${options.creatingScreen}`)
                                push(`/stickers/${stickerId}/new`)
                            ]));
                        }
                    })
            });
    };
}

export function loadComments(sticker) {
    return (dispatch, getState) => {
        const isLogged = isCurrentUserLoggedSelector(getState());

        dispatch(commentsLoadRequest());
        const commentsRepository = stickerCommentRepositoryBuilder.buildWithSticker(sticker);
        commentsRepository.search({per_page: 1000, page: 1})
            .then((response) => response.data)
            .then((comments) => {
                const unreadCommentsCount = comments.reduce((result, comment) => {
                    if (!comment.is_user_read) result++;
                    return result;
                }, 0);
                dispatch(commentsLoadSuccess({comments, unreadCommentsCount}));

                if (isLogged) {
                    // mark as read after load
                    commentsRepository.markCommentsAsRead();
                }
            })
            .catch((error) => dispatch(commentsLoadFailed(error)));
    };
}

export function attachStickerToCurrentUser(sticker) {
    return (dispatch, getState) => {
        dispatch(batchActions([
            stickerAttachRequest(),
            setAttachingStickerAfterLogin(null),
        ]));
        stickerRepository.attachStickerToCurrentUser(sticker)
            .then(() => dispatch(stickerAttachSuccess()))
            .catch(() => dispatch(stickerAttachFailed()));
    };
}

export function attachConfirm(stickerId) {
    return (dispatch, getState) => {
        const isLogged = isCurrentUserLoggedSelector(getState());
        const sticker = stickerSelector(getState(), stickerId);
        dispatch(setAttachModalVisibility(false));
        if (isLogged) {
            dispatch(attachStickerToCurrentUser(sticker));
        } else {
            dispatch(loginForAttachToSticker(sticker));
        }
    };
}

export function closeAttachModal() {
    return (dispatch, getState) => {
        dispatch(batchActions([
            setAttachModalVisibility(false),
            setAttachModalClosedFlag(true)
        ]));
    };
}

let attachingTimer;
const ATTACH_MODAL_DELAY_SEC = 20;

export function startAttachingTimer(sticker) {
    return (dispatch, getState) => {
        const isLogged = isCurrentUserLoggedSelector(getState());
        const currentUser = currentUserInfoSelector(getState());
        const isOwner = isLogged && currentUser.id === sticker.from.id;
        if (!isOwner) {
            attachingTimer = setTimeout(() => {
                dispatch(setAttachModalVisibility(true));
                attachingTimer = null;
            }, ATTACH_MODAL_DELAY_SEC * 1000);
        }
    };
}

export function onShowScreenDestroy() {
    return (dispatch, getState) => {
        if (attachingTimer) {
            clearTimeout(attachingTimer);
            attachingTimer = null;
        }
    };
}
